import { Box } from '@mui/material';

import { ClientNameSelect, HeaderDialogs, TpOptionsMenu } from './components';
import { useTreatmentPlanV3Header } from './hooks';
import { PdfDocument } from './pdfDocument';
import { HIDDEN_PDF_SX, TP_HEADER_ROOT_SX, TP_HEADER_ROW_SX } from './styles';

export default function TreatmentPlanV3Header() {
  const { clientSelect, menu, dialogs, report } = useTreatmentPlanV3Header();

  return (
    <Box data-testid="treatmentPlanBar" sx={TP_HEADER_ROOT_SX}>
      <Box sx={TP_HEADER_ROW_SX}>
        <ClientNameSelect {...clientSelect} />
        <TpOptionsMenu {...menu} />
      </Box>
      <HeaderDialogs {...dialogs} />
      {report.isReportReady ? (
        <Box sx={HIDDEN_PDF_SX}>
          <PdfDocument ref={report.contentRef} {...report.pdfProps} />
        </Box>
      ) : null}
    </Box>
  );
}
